import clsx from 'clsx';
import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { SuggestedOffer } from '@interfaces/models/negotiation/negotiationInitialData';
import styles from './suggested-offers.module.scss';

type SuggestedOffersProps = {
  suggestedOffers: SuggestedOffer[];
  onChange: (arg: number) => void;
  value: number;
};

export const SuggestedOffers: FC<SuggestedOffersProps> = ({ value, onChange, suggestedOffers }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.suggested__offers}>
      <p className={styles.suggested__offers__title}>{t('MMAO.BOTTOM.SHEET.SUGGESTED.OFFER.DESCRIPTION')}</p>
      <ul
        className={styles.suggested__offers__list}
        data-cy="suggested-offers-list"
      >
        {suggestedOffers?.map((offer, index) => (
          <li
            key={`${offer.offerLabel ?? ''}-${index}`}
            className={styles.suggested__offers__item}
          >
            <div
              role="button"
              onClick={() => onChange(index)}
              className={clsx(
                styles.suggested__offers__item__inner,
                value === index && styles['suggested__offers__item__inner--selected'],
                offer.recommended && styles['suggested__offers__item__inner--recommended'],
              )}
              tabIndex={0}
            >
              <p className={styles.suggested__offers__item__inner__price}>{offer.offerAmount?.formatted}</p>
              <p className={styles.suggested__offers__item__inner__discount}>
                {t('MMAO.SUGGESTED_OFFER.PRICE_DISCOUNT', {
                  discount: offer.offerLabel ?? '',
                })}
              </p>
            </div>
            {offer.recommended && (
              <div className={styles['suggested__offers__item--recommended']}>
                {t('MMAO.BOTTOM.SHEET.SUGGESTED.OFFER.PRICE.RECOMMENDED')}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
